var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWaitingIndicator = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11509_164011)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.8331 2.03646C12.7277 0.820883 10.2256 0.491479 7.87726 1.12071C5.52895 1.74993 3.52677 3.28625 2.3112 5.39169C1.09562 7.49713 0.76622 9.99922 1.39545 12.3475C2.02468 14.6958 3.56099 16.698 5.66643 17.9136C7.77187 19.1292 10.274 19.4586 12.6223 18.8293C14.9706 18.2001 16.9728 16.6638 18.1883 14.5584C19.4039 12.4529 19.7333 9.95083 19.1041 7.60251C18.4749 5.2542 16.9385 3.25203 14.8331 2.03646ZM6.49976 16.4702C4.77713 15.4757 3.52015 13.8375 3.00533 11.9162C2.4905 9.99483 2.76001 7.94766 3.75457 6.22502C4.74914 4.50239 6.38728 3.24541 8.30863 2.73059C10.23 2.21576 12.2771 2.48527 13.9998 3.47983C15.7224 4.4744 16.9794 6.11253 17.4942 8.03388C18.009 9.95522 17.7395 12.0024 16.745 13.725C15.7504 15.4477 14.1122 16.7046 12.1909 17.2195C10.2696 17.7343 8.2224 17.4648 6.49976 16.4702Z",
    fill: "#527BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4173 2.75782C14.1872 3.1564 14.3272 3.6625 14.6978 3.93539C16.0616 4.93955 17.0525 6.38191 17.4951 8.03355C17.9376 9.68519 17.8006 11.4298 17.1216 12.9813C16.9371 13.403 17.069 13.9112 17.4675 14.1414C17.8661 14.3715 18.3796 14.2362 18.5726 13.8184C19.4678 11.8804 19.662 9.68102 19.105 7.60219C18.5479 5.52336 17.2801 3.71579 15.5358 2.48502C15.1598 2.21968 14.6474 2.35924 14.4173 2.75782Z",
    fill: "#527BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11509_164011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.25)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaitingIndicator, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/waiting-indicator.169bd4ef.svg";
export { ForwardRef as ReactComponent };